import { Container } from '@ui/wrapper'
import Accordion from '@ui/accordion'
import { SectionWrapper, StyledText } from './style'

const StellungnahmenGutachtenArea = ({
  dataRegulierung,
  dataSteuern,
  ...rest
}) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {dataRegulierung && (
          <div>
            {dataRegulierung.section_title?.title && (
              <StyledText id="regulierung">
                <h4>{dataRegulierung.section_title.title}</h4>
              </StyledText>
            )}
            {dataRegulierung.items?.length > 0 && (
              <StyledText>
                <Accordion maxItems={5} data={dataRegulierung.items} />
              </StyledText>
            )}
          </div>
        )}
        {dataSteuern && (
          <div style={{ marginTop: '60px' }}>
            {dataSteuern.section_title?.title && (
              <StyledText id="steuern">
                <h4>{dataSteuern.section_title.title}</h4>
              </StyledText>
            )}
            {dataSteuern.items?.length > 0 && (
              <StyledText>
                <Accordion maxItems={5} data={dataSteuern.items} />
              </StyledText>
            )}
          </div>
        )}
      </Container>
    </SectionWrapper>
  )
}

export default StellungnahmenGutachtenArea
